import { useMediaQuery } from 'react-responsive';

export default function RenderOnMobile({
  children,
}) {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return isMobile ? children : null;
}
